/**
 * TanStack Query hooks for `affiliate-leaderboard-manual-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	affiliateLeaderboardManualWidgetQueryKeys,
	type CreateAffiliateLeaderboardManualWidgetBody,
	type ListAffiliateLeaderboardManualWidgetResponse,
	type AffiliateLeaderboardManualWidgetRow,
} from "./api";

export function useAffiliateLeaderboardManualWidgetList(): UseQueryResult<ListAffiliateLeaderboardManualWidgetResponse, Error> {
	return useQuery({
		queryKey: affiliateLeaderboardManualWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function useAffiliateLeaderboardManualWidgetCreate(): UseMutationResult<AffiliateLeaderboardManualWidgetRow, Error, CreateAffiliateLeaderboardManualWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateLeaderboardManualWidgetQueryKeys.all });
		},
	});
}

export function useAffiliateLeaderboardManualWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateLeaderboardManualWidgetQueryKeys.all });
		},
	});
}
